<template>
  <v-app id="inspire">
    <!-- <v-navigation-drawer v-model="drawer" :clipped="$vuetify.breakpoint.lgAndUp" app>
      <v-list dense>
        <template v-for="item in items">
          <v-row v-if="item.heading" :key="item.heading" align="center">
            <v-col cols="6">
              <v-subheader v-if="item.heading">{{ item.heading }}</v-subheader>
            </v-col>
            <v-col cols="6" class="text-center"></v-col>
          </v-row>
          <v-list-group
            v-else-if="item.children"
            :key="item.text"
            v-model="item.model"
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon
            :to="item.link"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title :to="item.link">{{ item.text }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item v-for="(child, i) in item.children" :to="child.link" :key="i" link>
              <v-list-item-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title :to="child.link">{{ child.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item v-else :key="item.text" :to="item.link" router exact>
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer> -->

    <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app color="blue darken-3" dark>
      <!-- <v-app-bar-nav-icon @click.stop="drawer = !drawer" /> -->
      <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
        <span class="hidden-sm-and-down">ENCODIFY</span>
      </v-toolbar-title>
     
      <router-link :to="'/base64-encode'">
        <v-btn text>Encode</v-btn>
      </router-link>
      <router-link :to="'/js-beautify'">
      <v-btn text>Beautify</v-btn>
      </router-link>
      <!-- <router-link :to="'/js-beautify'">
      <v-btn text>Minify</v-btn>
      </router-link> -->
      <router-link :to="'/md5-hash'">
      <v-btn text>Hash</v-btn>
      </router-link>
      <router-link :to="'/what-is-my-ip'">
      <v-btn text>Finders</v-btn>
      </router-link>
    </v-app-bar>

    <v-content>
      <!-- <v-container fluid> -->
        <router-view></router-view>
      <!-- </v-container> -->
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: "Layout",
  props: {
    source: String
  },
  data: () => ({
    dialog: false,
    drawer: null,
    items: [
      {
        icon: "mdi-chevron-up",
        "icon-alt": "mdi-chevron-down",
        text: "Encode",
        model: true,
        children: [
          {
            // icon: "mdi-account-balance-wallet",
            text: "Base64 Encode",
            link: "/base64-encode",
            model: true
          },
          {
            // icon: "mdi-account-box",
            text: "Base64 Decode",
            link: "/base64-decode"
          },
          {
            // icon: "mdi-contacts",
            text: "URL Encode",
            link: "/url-encode"
          },
          {
            // icon: "mdi-contacts",
            text: "URL Decode",
            link: "/url-decode"
          },
          // {
          //   // icon: "mdi-contacts",
          //   text: "URL Shortener",
          //   link: "/url-shortener"
          // },
          {
            // icon: "mdi-account-balance-wallet",
            text: "JWT Decode",
            link: "/jwt-decode"
          }
        ]
      },
      {
        icon: "mdi-chevron-up",
        "icon-alt": "mdi-chevron-down",
        text: "Finders",
        model: true,
        children: [
          {
            //   icon: "mdi-history",
            text: "What is my IP",
            link: "/what-is-my-ip"
          }

          // {
          //   // icon: "mdi-history",
          //   text: "Where am I",
          //   link: "/where-am-i"
          // }
        ]
      },
      //   { heading: "Finders" },

      //   { heading: "Beautify" },
      {
        icon: "mdi-chevron-up",
        "icon-alt": "mdi-chevron-down",
        text: "Beautify",
        model: true,
        children: [
          {
            text: "JS Beautify",
            link: "/js-beautify"
          },
          {
            text: "CSS Beautify",
            link: "/css-beautify"
          },
          {
            text: "HTML Beautify",
            link: "/html-beautify"
          },
          {
            text: "JSON Beautify",
            link: "/json-beautify"
          },
          {
            text: "XML Beautify",
            link: "/xml-beautify"
          }
        ]
      },
      // {
      //   icon: "mdi-chevron-up",
      //   "icon-alt": "mdi-chevron-down",
      //   text: "Minify",
      //   model: true,
      //   children: [
      //     {
      //       text: "HTML Minify",
      //       link: "/html-minify"
      //     },
      //     {
      //       text: "CSS Minify",
      //       link: "/css-minify"
      //     },
      //     {
      //       text: "JS Minify",
      //       link: "/js-minify"
      //     }
      //   ]
      // },

      {
        icon: "mdi-chevron-up",
        "icon-alt": "mdi-chevron-down",
        text: "Hash",
        model: true,
        children: [
          {
            // icon: "mdi-history",
            text: "MD5 Hash",
            link: "/md-hash"
          },
          {
            // icon: "mdi-history",
            text: "SHA1 Hash",
            link: "/sha1-hash"
          },
          {
            // icon: "mdi-history",
            text: "SHA256 Hash",
            link: "/sha256-hash"
          },
          {
            // icon: "mdi-history",
            text: "SHA512 Hash",
            link: "/sha512-hash"
          }
        ]
      }
    ]
  })
};
</script>